var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {}, _obj[_vm.$style['disabled']] = _vm.isLoading, _obj[_vm.$style['suggestion']] = true, _obj[_vm.$style['location-suggestion']] = true, _obj ),on:{"click":function($event){return _vm.sendSuggestion()}}},[_vm._v(" Me localiser 📍 "),(_vm.isLoading)?_c('span',{class:_vm.$style['loader']}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }